/**
 * Build our field labels for form
 */
export const getExtra = (t: Function) => {
  return {
    'chooseAccount.tradingAccount': {
      selectID: '',
    },
    'chooseLicense.type': {
      selectID: '',
    },
    'licenseDetails.manufacturer': {
      childExtraFilters: [
        {
          type: 'formField',
          formName: 'licenseDetails',
          formField: 'manufacturer',
          isExtra: true,
          isNested: true,
          value: 'selectID',
        },
        {
          type: 'formFieldParam',
          formName: 'chooseAccount',
          formField: 'tradingAccount',
          isExtra: true,
          value: 'selectID',
          paramName: '?account_id',
        },
      ],
    },
    'poNumber.chooseExistingOrNew': {
      options: [
        {
          id: 'use_existing',
          label: t('general:request_license.actions.use_existing_po_number'),
          value: 'use_existing',
        },
        {
          id: 'use_new',
          label: t('general:request_license.actions.add_new_po_number'),
          value: 'use_new',
        },
      ],
    },
  };
};
